export const i18n = {
  banks: {
    payment: {
      name: "Transferencia Bancaria",
    },
  },
};
